export default __webpack_public_path__ + "static/media/bg-lg-right-4.fbd6d227.svg";